import Route from '@ember/routing/route';

const TASKS = [
  'loadSearchResults',
  'lookupCompaniesByName',
  'lookupBuyer',
  'lookupSeller',
  'lookupUser',
];

const QUERY_PARAMS = [
  'status',
  'simple_status',
  'company_id',
  'buyer_id',
  'seller_id',
  'sort',
  'secondary_sort',
];

const initializeMap = (keys, initialValue) => keys.reduce((accum, x) => {
  accum[x] = initialValue;
  return accum;
}, { });

class AdminProjectsRoute extends Route {
  queryParams = QUERY_PARAMS.reduce((accum, key) => {
    accum[key] = { replace: true };
    return accum;
  }, { });

  setupController(controller, _, transition) {
    super.setupController(...arguments);

    const initialFilter = transition.to.queryParams.simple_status
      ? 'simple_status'
      : 'status';

    controller.set('filter_by', initialFilter);
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      TASKS.forEach((method) => {
        controller[method].cancelAll({ resetState: true });
      });

      controller.setProperties({
        ...initializeMap(QUERY_PARAMS, null),
        page: 1,
      });
    }
  }
}

export default AdminProjectsRoute;
